module.exports = __webpack_public_path__ + "static/media/okinava.9ba0196c.webp";